import axios from "axios";
import { getAuthHeader } from "../util/util";

export function addRequestBodyHeader(request) {
  return request;
}

export const getHeader = (revealHeader) => {
  return getAuthHeader(revealHeader);
};
const instance = axios.create();

export const scheduleInstance = axios.create();
scheduleInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return error.response;
  }
);

export default instance;
